//
// Module for the Account Transaction adjustment's page.
//
rs.module("content/participant/member/disabilityapplication/edit",

    [/* Dependencies */],

    function () {

        function initialize(jsSelectors, disabilityCausesGrid, cssSelectors) {

            var disabilityForm = $.js(jsSelectors.disabilityForm);
            var disabilityAddLink = disabilityForm.js(jsSelectors.disabilityAddLink);

            var historyContainer = $.js(jsSelectors.historyContainer, { required: false });
            var historyPanel = $.js(jsSelectors.historyPanel, { required: false });

            // Handle the add link button for the salary grid
            disabilityAddLink.click(function () {
                disabilityCausesGrid.addRow();
            });

            if (historyContainer && historyPanel) {
                // show/hide DROP account status history on hover with intent
                historyContainer.hoverIntent({
                    handlerOver: function (event) {
                        historyPanel.toggleClass(cssSelectors.visible, true);
                    },
                    handlerOut: function (event) {
                        historyPanel.toggleClass(cssSelectors.visible, false);
                    },
                    hoverOutDelay: 400
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);